import { i18n } from '@js/i18n'
import { documentTypes } from '@const'

export default {
  form: {
    shortDescription: '',
    // docs: {
    //   [documentTypes.fundLogo]: null
    // }
  },
  // requiredDocs: [documentTypes.fundLogo],
  rows: [
    [
      {
        "field": "file",
        "fileType": "image",
        "fieldType": "tokenCreation",
        "id": "sale-token-logo",
        "name": "sale-token-logo",
        "type": documentTypes.fundLogo,
        "private": false,
        "label": i18n.sale_token_logo_title(),
        "required": true,
        "validate": "required"
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/saleCreation/specs/step-3.token.schema.js